import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d11d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "navbar",
  class: "navbar is-dark is-full is-fixed-top",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = { class: "container is-widescreen" }
const _hoisted_3 = { class: "navbar-brand ml-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title has-text-light" }, "Survey creator", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "navbar-start pr-4"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Surveys ")
const _hoisted_12 = { class: "navbar-end pr-4" }
const _hoisted_13 = { class: "navbar-item" }
const _hoisted_14 = {
  key: 0,
  class: "buttons"
}
const _hoisted_15 = {
  key: 1,
  class: "buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SButton = _resolveComponent("SButton")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "navbar-item pl-4",
          to: {name: _ctx.homeRouteName}
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("a", {
          ref: "navbarBurger",
          role: "button",
          class: _normalizeClass(["navbar-burger", {
						'is-active': _ctx.showMobileMenu
					}]),
          "aria-label": "menu",
          "aria-expanded": "false"
        }, _hoisted_8, 2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-menu", {
					'is-active': _ctx.showMobileMenu
				}])
      }, [
        (_ctx.isAuthorized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "navbar-item",
                to: {name: _ctx.homeRouteName}
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "navbar-item",
                to: {name: _ctx.surveysRouteName}
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_ctx.isAuthorized)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_SButton, {
                    "button-text": "Log out",
                    sm: "",
                    onClick: _ctx.onLogOutButtonClick
                  }, null, 8, ["onClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_SButton, {
                    "button-text": "Sign up",
                    sm: "",
                    onClick: _ctx.onSignUpButtonClick
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_SButton, {
                    color: "link",
                    "button-text": "Log in",
                    sm: "",
                    onClick: _ctx.onLogInButtonClick
                  }, null, 8, ["onClick"])
                ]))
          ])
        ])
      ], 2)
    ])
  ], 512))
}